import { parseDurationToMinutes } from './appointmentBookingUtils';

const durationMinutes = (service) => parseDurationToMinutes(service?.duration);

const isBetterCover = (candidate, current) => {
  const candidateCount = candidate.serviceIds.length;
  const currentCount = current.serviceIds.length;
  if (candidateCount !== currentCount) {
    return candidateCount > currentCount;
  }

  const candidatePrice = Number(candidate.price);
  const currentPrice = Number(current.price);
  if (candidatePrice !== currentPrice) {
    return candidatePrice < currentPrice;
  }

  const candidateDuration = durationMinutes(candidate);
  const currentDuration = durationMinutes(current);
  if (candidateDuration !== currentDuration) {
    return candidateDuration < currentDuration;
  }

  return candidate.id < current.id;
};

export const matchServiceCombos = (selectedServices, catalogServices, lockedServiceIds = []) => {
  const selected = selectedServices || [];
  const locked = new Set(lockedServiceIds || []);
  const combos = (catalogServices || []).filter((service) => (
    service?.isCombo
    && !service.disabled
    && Array.isArray(service.serviceIds)
    && service.serviceIds.length >= 2
    && !service.serviceIds.some((serviceId) => locked.has(serviceId))
  ));
  const comboById = new Map(combos.map((combo) => [combo.id, combo]));
  const remaining = new Set(selected.map((service) => service.id));
  const chosen = [];

  selected.forEach((service) => {
    const combo = comboById.get(service.id);
    if (!combo || chosen.some((item) => item.id === combo.id)) {
      return;
    }

    chosen.push(combo);
    remaining.delete(combo.id);
    combo.serviceIds.forEach((serviceId) => remaining.delete(serviceId));
  });

  const available = combos.filter((combo) => !chosen.some((item) => item.id === combo.id));
  while (available.length > 0) {
    let best = null;
    available.forEach((combo) => {
      if (!combo.serviceIds.every((serviceId) => remaining.has(serviceId))) {
        return;
      }

      if (!best || isBetterCover(combo, best)) {
        best = combo;
      }
    });

    if (!best) {
      break;
    }

    chosen.push(best);
    best.serviceIds.forEach((serviceId) => remaining.delete(serviceId));
    const index = available.findIndex((combo) => combo.id === best.id);
    available.splice(index, 1);
  }

  const ordered = [];
  chosen.forEach((combo) => ordered.push(combo));
  selected.forEach((service) => {
    if (remaining.delete(service.id)) {
      ordered.push(service);
    }
  });

  return ordered;
};

export const matchServiceComboIds = (selectedServiceIds, catalogServices, lockedServiceIds = []) => {
  const byId = new Map((catalogServices || []).map((service) => [service.id, service]));
  const selected = (selectedServiceIds || [])
    .map((serviceId) => byId.get(serviceId))
    .filter(Boolean);

  return matchServiceCombos(selected, catalogServices, lockedServiceIds).map((service) => service.id);
};
